<div class="appearance">
  <div class="st-head">
    <div class="st-head-copy">
      <div class="st-eyebrow">Personal</div>
      <h1 class="st-h1">Appearance</h1>
      <p class="st-lead">Make Forensic Notes yours. Choose a theme and fine-tune individual colours.
        Changes save automatically and apply everywhere, just for you.</p>
    </div>
  </div>

  <!-- THEME MODE -->
  <div class="st-panel section">
    <div class="st-panel-head">
      <mat-icon>contrast</mat-icon>
      <h2 class="st-h2">Theme</h2>
    </div>
    <div class="mode-grid">
      <button type="button" class="mode" *ngFor="let m of modes"
        [class.active]="themeService.mode === m.value" (click)="setMode(m.value)">
        <span class="material-icons">{{ m.icon }}</span>
        <span class="m-label">{{ m.label }}</span>
        <span class="m-hint">{{ m.hint }}</span>
      </button>
    </div>
  </div>

  <!-- CUSTOM COLOURS -->
  <div class="st-panel section">
    <div class="st-panel-head">
      <mat-icon>palette</mat-icon>
      <h2 class="st-h2">Custom colours</h2>
      <button type="button" class="reset-all" *ngIf="personalization.anyCustomized" (click)="resetAll()">
        <span class="material-icons">restart_alt</span> Reset all
      </button>
    </div>

    <div class="rows">
      <div class="crow" *ngFor="let t of tokens">
        <label class="swatch-wrap" [attr.title]="'Pick ' + t.label">
          <span class="swatch" [style.background]="swatch(t)"></span>
          <input type="color" class="picker" [value]="swatch(t)"
            (input)="onColor(t, $any($event.target).value)">
        </label>
        <div class="meta">
          <div class="c-label">{{ t.label }}
            <span class="tag" *ngIf="personalization.isCustomized(t.key)">Custom</span>
          </div>
          <div class="c-desc">{{ t.description }}</div>
        </div>
        <div class="controls">
          <input type="text" class="hex" spellcheck="false" maxlength="7"
            [value]="swatch(t)" (change)="onHexInput(t, $any($event.target).value)">
          <button type="button" class="reset" [class.hidden]="!personalization.isCustomized(t.key)"
            (click)="reset(t)" title="Reset to theme default">
            <span class="material-icons">restart_alt</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- LIVE PREVIEW -->
  <div class="st-panel section">
    <div class="st-panel-head">
      <mat-icon>visibility</mat-icon>
      <h2 class="st-h2">Live preview</h2>
    </div>
    <div class="preview">
      <div class="pv-title">Case 2024-0417 — Riverside</div>
      <p class="pv-body">This is how your notes and forms will look. Adjust the colours above and
        this preview updates instantly. <a href="javascript:void(0)" (click)="$event.preventDefault()">In-content link</a>.</p>
      <label class="pv-label">Sample textbox</label>
      <input type="text" class="pv-input" placeholder="Type a note…" value="Interview with witness A">
      <div class="pv-actions">
        <span class="pv-demo">
          <span class="pv-tip" *ngIf="demoPoke === 'save'">Preview only — thanks for testing! 🎨</span>
          <button type="button" class="pv-btn success" (click)="pokeDemo('save')">Save &amp; Timestamp</button>
        </span>
        <span class="pv-demo">
          <span class="pv-tip" *ngIf="demoPoke === 'cancel'">Just a demo button, not the real thing</span>
          <button type="button" class="pv-btn ghost" (click)="pokeDemo('cancel')">Cancel</button>
        </span>
      </div>
    </div>
  </div>
</div>
